import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { HiShieldCheck, HiSparkles } from './Icons';

function AppFooter() {
  const currentYear = new Date().getFullYear();

  return (
    <div className="modern-footer-inner">
      <Container>
        <Row className="gy-4 mb-4">
          <Col lg={5} md={12}>
            <div className="footer-brand-col">
              <Link to="/" className="footer-brand-lockup mb-3 d-inline-flex align-items-center gap-3">
                <div className="brand-vector-icon footer-vector-icon">
                  <HiSparkles className="brand-svg-icon" />
                </div>
                <div className="brand-text-block">
                  <span className="brand-title footer-brand-title">
                    Coupon<span className="brand-title-gradient">Showcase</span>
                  </span>
                  <span className="brand-tagline">Deals & Rabattcodes</span>
                </div>
              </Link>
              <p className="footer-desc">
                Coupon Showcase ist dein vertrauenswürdiges Portal für handverlesene Gutscheine, Rabattcodes und exklusive Einladungsprämien für Top-Marken.
              </p>
              <div className="footer-trust-badge">
                <HiShieldCheck className="text-success me-1" />
                <span>100% Geprüfte Gutscheine & Angebote</span>
              </div>
            </div>
          </Col>

          <Col lg={3} md={6} sm={6}>
            <h5 className="footer-heading">Kategorien & Deals</h5>
            <ul className="footer-links-list">
              <li><Link to="/kategorie/finanzen-karten">💳 Finanzen & Kreditkarten</Link></li>
              <li><Link to="/kategorie/food-delivery">🍕 Food & Delivery</Link></li>
              <li><Link to="/kategorie/mobilitaet">🛴 Mobilität & Fahrten</Link></li>
              <li><Link to="/kategorie/finanzen-banking">🏦 Girokonten & Banking</Link></li>
              <li><Link to="/kategorie/tech-miete">📱 Technik mieten</Link></li>
            </ul>
          </Col>

          <Col lg={4} md={6} sm={6}>
            <h5 className="footer-heading">Transparenz & Info</h5>
            <p className="footer-disclaimer">
              Hinweis: Einige Links auf dieser Seite sind Weiterempfehlungs- oder Partnerlinks. Wenn du über diese Links ein Angebot nutzt, erhalten sowohl du als auch wir eine Prämie oder einen Rabatt. Für dich entstehen keinerlei zusätzliche Kosten.
            </p>
          </Col>
        </Row>

        <div className="footer-bottom-bar pt-4 border-top border-secondary border-opacity-25 d-flex flex-wrap justify-content-between align-items-center gap-2">
          <div className="copyright text-muted">
            &copy; {currentYear} Zhou. All Rights Reserved.
          </div>
          <div className="footer-subtext text-muted small">
            Made with <HiSparkles className="text-warning" /> for Smart Savers • <Link to="/" className="text-muted">couponshowcase.com</Link>
          </div>
        </div>
      </Container>
    </div>
  );
}

export default AppFooter;